export default __webpack_public_path__ + "static/media/account.5d63fc86.svg";